const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Normaliza a rota para a trilha das testadoras: sem query/hash, ids viram ":id", máx. 200 caracteres. */
export function normalizarRota(pathname: string): string {
  const semExtra = (pathname || "/").split("#")[0].split("?")[0] || "/";
  const rota = semExtra
    .split("/")
    .map((s) => (UUID.test(s) || /^\d+$/.test(s) ? ":id" : s))
    .join("/");
  return rota.slice(0, 200) || "/";
}
